import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), { key: 0 }))
    : _createCommentVNode("", true)
}